import { genSts } from "./api";
import OSS from "ali-oss";
export const getImgMixin = {
    data() {
        return {
            ossInstance: {},
            mixin_imgs: {},
        };
    },
    created() {
        this.genSts();
    },
    methods: {
        genSts() {
            genSts().then((r) => {
                if (r.code === 200) {
                    this.ossInstance = new OSS({
                        ...r.result,
                        cname: true,
                        stsToken: r.result.securityToken,
                        bucket: r.result.bucketName,
                    });
                    console.warn("SUCC------OSS图片初始化成功！！");
                }
            });
        },
        getOSSImg(str) {
            if (!str) return "";
            if (!this.ossInstance.signatureUrl) {
                console.log("ERROR----- OSS图片初始化未成功");
                return str;
            }
            if (this.mixin_imgs[str]) {
                //图片缓存
                console.log("拿到缓存图片地址", this.mixin_imgs[str]);
                return str;
            }
            this.mixin_imgs[str] = this.ossInstance.signatureUrl(str, {
                expires: 86400,
            });
            console.log("第一次拿到图片，并进行缓存处理",this.mixin_imgs[str])
            return str;
        },
    },
};



// WEBPACK FOOTER //
// src/pages/saleCar/getImg_mixin.js